import React from "react";
import { Box, Container, Typography, Paper } from "@mui/material";

const ArtistRights = () => {
  return (
    <Box sx={{ py: 8 }}>
      <Container maxWidth="md">
        <Paper elevation={3} sx={{ p: 4 }}>
          <Typography variant="h5" gutterBottom>
            Artist Rights & Platform Terms Summary
          </Typography>
          <Typography variant="body1" gutterBottom>
            A platform built by artists and music lovers—for artists and music lovers.
          </Typography>

          <Typography variant="subtitle1" sx={{ mt: 4 }}>
            What You’re Signing Up For
          </Typography>
          <Typography paragraph>
            By joining the Lsnto artist waitlist, you're expressing interest in:
            <ul>
              <li>Participating in a new streaming experience that values authenticity and direct fan engagement.</li>
              <li>Gaining early access to tools that support <strong>exclusive</strong> and <strong>non-exclusive</strong> music publishing—on your terms.</li>
              <li>Being part of a community that promotes <strong>fair exposure</strong>, real audience connections, and artist-first monetisation models.</li>
            </ul>
          </Typography>

          <Typography variant="subtitle1" sx={{ mt: 4 }}>
            Your Rights Remain Yours
          </Typography>
          <Typography paragraph>
            <ul>
              <li><strong>You always own your masters.</strong></li>
              <li>Lsnto does not claim copyright, publishing rights, or control over your identity or music.</li>
              <li>Any <strong>exclusive content</strong> you choose to publish with Lsnto remains non-binding — you may distribute it elsewhere if you wish.</li>
              <li>Exclusivity simply helps your content reach its full potential <em>within</em> Lsnto.</li>
            </ul>
          </Typography>

          <Typography variant="subtitle1" sx={{ mt: 4 }}>
            Fair Use & Platform Integrity
          </Typography>
          <Typography paragraph>
            To protect both artists and fans, we reserve the right to:
            <ul>
              <li>Enforce a <strong>fair usage policy</strong> to ensure the platform remains high-quality and equitable.</li>
              <li>Restrict or revoke access from users who:
                <ul>
                  <li>Upload fraudulent, plagiarised, or misleading content.</li>
                  <li>Engage in abusive, racist, sexist, or otherwise immoral or unlawful behaviour.</li>
                  <li>Attempt to manipulate streaming stats, monetisation, or visibility unfairly.</li>
                </ul>
              </li>
            </ul>
          </Typography>

          <Typography variant="subtitle1" sx={{ mt: 4 }}>
            Platform Principles
          </Typography>
          <Typography paragraph>
            <ul>
              <li>We <strong>reward real engagement</strong>, not bots or hype.</li>
              <li>We don’t allow white noise, filler content, or AI spam to dilute the experience.</li>
              <li>Every stream, connection, and reward on Lsnto should reflect meaningful musical impact.</li>
            </ul>
          </Typography>

          <Typography sx={{ mt: 4 }}>
            By joining our waitlist, you're not committing to any exclusivity or platform lock-in. You're simply raising your hand to say: <strong>"I believe there’s a better way". </strong>
            We’ll keep you informed of the next steps and how to claim your artist profile when we’re ready to open the doors.
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
};

export default ArtistRights;